import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  selectFirestopAdditionAttributes,
  selectFirestopImagesToAdd,
  selectSelectedAdditionFirestopItemId,
} from '../selectors/firestop-documentation.selectors';
import { postCreateFirestopAddition } from '../services/post-create-firestop-addition.service';

export const createFirestopAddition = createAsyncThunk(
  'firestopDocumentation/createDefectAddition',
  async (_, { getState }) => {
    const additionFirestopItemId =
      selectSelectedAdditionFirestopItemId(getState());

    const firestopImagesToAdd = selectFirestopImagesToAdd(getState());

    const firestopAdditionAttributes =
      selectFirestopAdditionAttributes(getState());

    const updateData = await postCreateFirestopAddition(
      additionFirestopItemId,
      firestopAdditionAttributes,
      firestopImagesToAdd
    );

    return updateData;
  }
);
